(function () {
  if (window.__af4v2) return;
  window.__af4v2 = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var state = { variantId: null, qty: 1, price: 0 };

  function cfg() {
    var el = document.querySelector('[data-af4-config]');
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  }

  function money(cents) {
    var c = cfg();
    var fmt = c.moneyFormat || '${{amount}}';
    var v = (Math.round(cents) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, v);
  }

  function toast(msg) {
    var old = document.querySelector('.a4-toast');
    if (old) old.remove();
    var el = document.createElement('div');
    el.className = 'a4-toast';
    el.innerHTML = '<span class="a4-toast__tick">✓</span><span></span>';
    el.lastChild.textContent = msg;
    document.body.appendChild(el);
    setTimeout(function () { el.remove(); }, 3200);
  }

  function currentVariant() {
    var c = cfg();
    var list = c.variants || [];
    for (var i = 0; i < list.length; i++) if (list[i].id === state.variantId) return list[i];
    return list[0] || {};
  }

  function paint() {
    var v = currentVariant();
    state.price = v.price || 0;
    document.querySelectorAll('[data-af4-qty-val]').forEach(function (el) { el.textContent = state.qty; });
    document.querySelectorAll('[data-af4-line-total]').forEach(function (el) { el.textContent = money(state.price * state.qty); });
    document.querySelectorAll('[data-af4-cur-price]').forEach(function (el) { el.textContent = money(state.price); });
    document.querySelectorAll('[data-af4-cur-label]').forEach(function (el) { el.textContent = v.title || ''; });
    document.querySelectorAll('[data-af4-cur-quarter]').forEach(function (el) { el.textContent = money(state.price / 4); });
    document.querySelectorAll('[data-af4-cur-exgst]').forEach(function (el) { el.textContent = money(state.price / 1.1); });
    document.querySelectorAll('[data-af4-cur-perkg]').forEach(function (el) {
      el.textContent = v.kg ? money(state.price / v.kg) : '';
    });
    document.querySelectorAll('[data-af4-cur-best]').forEach(function (el) { el.textContent = v.best || ''; });
    document.querySelectorAll('[data-af4-cur-stock]').forEach(function (el) {
      var avail = v.available !== false;
      el.textContent = avail ? (el.dataset.af4In || el.textContent) : (el.dataset.af4Out || '');
      el.hidden = !avail && !el.dataset.af4Out;
    });
    document.querySelectorAll('[data-af4-size]').forEach(function (b) {
      b.classList.toggle('is-active', parseInt(b.dataset.af4Size, 10) === state.variantId);
    });
    document.querySelectorAll('[data-af4-add]').forEach(function (b) {
      var avail = v.available !== false;
      b.disabled = !avail;
      var lbl = b.querySelector('[data-af4-add-label]');
      if (lbl && !b.dataset.af4Busy) lbl.textContent = avail ? (cfg().addLabel || 'Add to cart') : (cfg().soldOutLabel || 'Sold out');
    });
  }

  function setVariant(id) {
    state.variantId = id;
    paint();
  }

  function add(variantId, quantity, label) {
    var api = window.__twsQuickAdd;
    if (!api) return Promise.reject(new Error('quick add unavailable'));
    return api.addAndAnnounce(variantId, quantity).then(function (res) {
      toast(label || 'Added to cart');
      return res;
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null;
    if (!t) return;

    var dec = t.closest('[data-af4-qty-dec]');
    if (dec) { state.qty = Math.max(1, state.qty - 1); paint(); return; }

    var inc = t.closest('[data-af4-qty-inc]');
    if (inc) { state.qty = Math.min(99, state.qty + 1); paint(); return; }

    var size = t.closest('[data-af4-size]');
    if (size) { setVariant(parseInt(size.dataset.af4Size, 10)); return; }

    // The IT buy box (fc-hero-buybox) drives variants by index, so mirror it
    // rather than shipping a second, competing selector.
    var fcVar = t.closest('[data-fc-var]');
    if (fcVar) {
      var list = cfg().variants || [];
      var picked = list[parseInt(fcVar.dataset.fcVar, 10)];
      if (picked) setVariant(picked.id);
      return;
    }

    var atc = t.closest('[data-af4-add]');
    if (atc) {
      e.preventDefault();
      if (atc.dataset.af4Busy) return;
      var v = currentVariant();
      if (!v.id || v.available === false) return;
      atc.dataset.af4Busy = '1';
      atc.setAttribute('aria-busy', 'true');
      add(v.id, state.qty, state.qty + ' × ' + (cfg().title || 'Product') + ' added to cart')
        .catch(function () { toast('Sorry, that could not be added.'); })
        .then(function () {
          delete atc.dataset.af4Busy;
          atc.removeAttribute('aria-busy');
          paint();
        });
      return;
    }

    var one = t.closest('[data-af4-add-one]');
    if (one) {
      e.preventDefault();
      if (one.dataset.af4Busy) return;
      one.dataset.af4Busy = '1';
      one.setAttribute('aria-busy', 'true');
      add(parseInt(one.dataset.af4AddOne, 10), 1, one.dataset.af4Label || 'Added to cart')
        .catch(function () { toast('Sorry, that could not be added.'); })
        .then(function () { delete one.dataset.af4Busy; one.removeAttribute('aria-busy'); });
      return;
    }

    var all = t.closest('[data-af4-add-all]');
    if (all) {
      e.preventDefault();
      if (all.dataset.af4Busy) return;
      var ids = (all.dataset.af4AddAll || '').split(',').filter(Boolean).map(Number);
      if (!ids.length) return;
      all.dataset.af4Busy = '1';
      all.setAttribute('aria-busy', 'true');
      ids.reduce(function (chain, id) {
        return chain.then(function () { return window.__twsQuickAdd.add(id, 1); });
      }, Promise.resolve())
        .then(function () {
          return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            window.__twsQuickAdd.announce({ cart: cart, items: [] });
            toast(ids.length + ' items added to cart');
          });
        })
        .catch(function () { toast('Some items could not be added.'); })
        .then(function () { delete all.dataset.af4Busy; all.removeAttribute('aria-busy'); });
    }
  });

  /* ---------- before / after drag slider ---------- */
  function initSlider(el) {
    if (el.dataset.af4Ready) return;
    el.dataset.af4Ready = '1';
    var dragging = false;
    function setPos(clientX) {
      var r = el.getBoundingClientRect();
      var pct = ((clientX - r.left) / r.width) * 100;
      pct = Math.max(4, Math.min(96, pct));
      el.style.setProperty('--a4-split', pct + '%');
      var handle = el.querySelector('[data-af4-ba-handle]');
      if (handle) handle.setAttribute('aria-valuenow', Math.round(pct));
    }
    el.addEventListener('pointerdown', function (e) {
      dragging = true;
      try { el.setPointerCapture(e.pointerId); } catch (err) {}
      setPos(e.clientX);
      e.preventDefault();
    });
    el.addEventListener('pointermove', function (e) { if (dragging) setPos(e.clientX); });
    // pointerleave must not end the drag: with pointer capture it fires as soon as
    // the cursor crosses the frame edge, which stopped the slider mid drag.
    ['pointerup', 'pointercancel'].forEach(function (ev) {
      el.addEventListener(ev, function (e) {
        dragging = false;
        try { el.releasePointerCapture(e.pointerId); } catch (err) {}
      });
    });
    el.addEventListener('keydown', function (e) {
      var cur = parseFloat(getComputedStyle(el).getPropertyValue('--a4-split')) || 52;
      if (e.key === 'ArrowLeft') { el.style.setProperty('--a4-split', Math.max(4, cur - 4) + '%'); e.preventDefault(); }
      if (e.key === 'ArrowRight') { el.style.setProperty('--a4-split', Math.min(96, cur + 4) + '%'); e.preventDefault(); }
    });
  }

  /* ---------- sticky purchase bar ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-af4-sticky]');
    var anchor = document.querySelector('[data-af4-sticky-after]');
    if (!bar || !anchor) return;
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-on', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(anchor);
  }

  /* ---------- coverage calculator ---------- */
  // rate is m2 per kg for the WHOLE system (TDS practical yield: 1 kg ~ 3 m2,
  // three thin coats, diluted 2:1, over tiles), so coats do not multiply it.
  // Each surface chip carries a usage factor against that tiled rate.
  function initCalc(el) {
    if (el.dataset.af4Ready) return;
    el.dataset.af4Ready = '1';
    var d = el.dataset;
    var rate = parseFloat(d.af4Rate) || 3;          // m2 per kg, full system
    var water = parseFloat(d.af4Water) || 0;        // L water per kg for brush / roller
    var packs = JSON.parse(d.af4Packs || '[]');     // [{id,kg,price,label,available}]
    var st = { area: parseInt(d.af4Area, 10) || 20, coats: parseInt(d.af4Coats, 10) || 3, surface: 0 };

    function surfaceFactor() {
      var chip = el.querySelectorAll('[data-af4-surface]')[st.surface];
      return (chip && parseFloat(chip.dataset.af4Surface)) || 1;
    }

    // Cheapest pack mix that covers kgNeeded (fewest packs on a price tie).
    function best(kgNeeded) {
      var usable = packs.filter(function (p) { return p.available !== false && p.kg > 0; });
      if (!usable.length) return { list: [], kg: 0, cost: 0 };
      var need = Math.max(1, Math.ceil(kgNeeded * 10 - 0.001));
      var cap = need + Math.ceil(Math.max.apply(null, usable.map(function (p) { return p.kg; })) * 10);
      var dp = [{ cost: 0, n: 0, prev: -1, pack: null }];
      for (var t = 1; t <= cap; t++) {
        dp[t] = null;
        usable.forEach(function (p) {
          var k = Math.round(p.kg * 10), from = dp[t - k];
          if (k > t || !from) return;
          var cost = from.cost + p.price, n = from.n + 1, cur = dp[t];
          if (!cur || cost < cur.cost || (cost === cur.cost && n < cur.n)) dp[t] = { cost: cost, n: n, prev: t - k, pack: p };
        });
      }
      var pick = -1;
      for (var u = need; u <= cap; u++) {
        if (!dp[u]) continue;
        if (pick < 0 || dp[u].cost < dp[pick].cost || (dp[u].cost === dp[pick].cost && dp[u].n < dp[pick].n)) pick = u;
      }
      var out = [];
      for (var i = pick; i > 0; i = dp[i].prev) out.push(dp[i].pack);
      out.sort(function (a, b) { return b.kg - a.kg; });
      var kg = out.reduce(function (a, p) { return a + p.kg; }, 0);
      return { list: out, kg: kg, cost: dp[pick].cost };
    }

    function render() {
      var kgNeeded = st.area / rate * surfaceFactor();
      var rec = best(kgNeeded);
      var counts = {};
      rec.list.forEach(function (p) { counts[p.label] = (counts[p.label] || 0) + 1; });
      var summary = Object.keys(counts).map(function (k) { return counts[k] + ' × ' + k; }).join(' + ') || '-';

      var set = function (sel, val) { el.querySelectorAll(sel).forEach(function (n) { n.textContent = val; }); };
      var kgShown = Math.round(kgNeeded * 10) / 10;
      set('[data-af4-calc-area]', st.area);
      set('[data-af4-calc-coats]', st.coats);
      set('[data-af4-calc-kg]', kgShown.toFixed(1));
      set('[data-af4-calc-first]', kgShown.toFixed(1));
      set('[data-af4-calc-water]', (Math.round(kgNeeded * water * 10) / 10).toFixed(1));
      set('[data-af4-calc-packs]', summary);
      set('[data-af4-calc-cost]', money(rec.cost));

      el.querySelectorAll('button[data-af4-coats]').forEach(function (b) {
        b.classList.toggle('is-active', parseInt(b.dataset.af4Coats, 10) === st.coats);
      });
      el.querySelectorAll('[data-af4-surface]').forEach(function (b, i) {
        b.classList.toggle('is-active', i === st.surface);
      });
      var buy = el.querySelector('[data-af4-calc-buy]');
      if (buy) {
        buy.dataset.af4AddAll = rec.list.map(function (p) { return p.id; }).join(',');
        var lbl = buy.querySelector('[data-af4-calc-buy-label]');
        if (lbl) lbl.textContent = summary;
      }
    }

    // Match the controls themselves: the grid also carries data-af4-area /
    // data-af4-coats until the section script strips them.
    el.addEventListener('input', function (e) {
      var r = e.target.closest('input[data-af4-area]');
      if (r) { st.area = parseInt(r.value, 10); render(); }
    });
    el.addEventListener('click', function (e) {
      var c = e.target.closest('button[data-af4-coats]');
      if (c) { st.coats = parseInt(c.dataset.af4Coats, 10); render(); return; }
      var s = e.target.closest('[data-af4-surface]');
      if (s) {
        st.surface = [].indexOf.call(el.querySelectorAll('[data-af4-surface]'), s);
        render();
      }
    });
    render();
  }

  /* ---------- gallery pickers (use cases, projects) ---------- */
  function initPicker(el) {
    if (el.dataset.af4Ready) return;
    el.dataset.af4Ready = '1';
    el.addEventListener('click', function (e) {
      var b = e.target.closest('[data-af4-pick]');
      if (!b) return;
      var key = b.dataset.af4Pick;
      el.querySelectorAll('[data-af4-pick]').forEach(function (n) { n.classList.toggle('is-active', n === b); });
      el.querySelectorAll('[data-af4-panel]').forEach(function (n) { n.hidden = n.dataset.af4Panel !== key; });
    });
  }

  function boot() {
    var c = cfg();
    if (c.selectedId) state.variantId = c.selectedId;
    document.querySelectorAll('[data-af4-ba]').forEach(initSlider);
    document.querySelectorAll('[data-af4-calc]').forEach(initCalc);
    document.querySelectorAll('[data-af4-picker]').forEach(initPicker);
    initSticky();
    paint();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
